import { api } from '@api'
import type { CreateMessage } from '@hvf/contracts'
import { processMessageMedia } from './messageMediaUtils'

export const whenInsertMessage = async (message: CreateMessage) => {
  // 1. Process all media and update HTML content
  const { updatedContent, mentions } = await processMessageMedia(message.content, message.channel_id)

  // 2. Insert the actual message record
  const { data: insertedMessage, error: messageError } = await api()
    .from('message')
    .insert({
      ...message,
      content: updatedContent,
    })
    .select()
    .single()

  if (messageError) throw new Error(messageError.message)

  // 3. Insert mentions if any exist
  if (mentions.length > 0) {

    const mentionPayload = mentions.map(m => ({
      user_id: m.userId!,
      message_id: insertedMessage.id,
      channel_id: message.channel_id,
      username: m.username!,
    }))

    const { error: mentionError } = await api().from('message_mention').insert(mentionPayload)
    if (mentionError) console.error('Failed to insert mentions:', mentionError)
  }

  return insertedMessage
}
